import type legacyStorageTypes from "./storage/legacyStorageTypes";

export const emptyCache: legacyStorageTypes = {
  classInfo: [],
  grade: [],
  level: [],
  major: [],
  majorModuleGrade: [],
  module: [],
  moduleGroup: [],
  moduleTags: [],
  schoolInfo: [],
  staffInfo: [],
  studentInfo: [],
  topic: [],
  topicTags: [],
  subModuleGroup: [],
};
